import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Badge from '@mui/material/Badge';


import AboutLadder from './aboutLadder';
import StickyHeadTable from './table'

import { db } from '../../firebase';
import firebase from "firebase";
import { Paper } from '@material-ui/core';


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


export default function BasicTabs(props) {
    const [value, setValue] = React.useState(0);
    const [mypendings, setmypendings] = React.useState([])
    const { match } = props

    // console.log(match.path)

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };


    function getPendings() {
        db.collection("ladderpendings").get().then((querySnapshot) => {
            let new_pendings = []
            querySnapshot.forEach((doc) => {
                // doc.data() is never undefined for query doc snapshots
                const documentId = doc.id
                doc = doc.data()
                doc.documentId = documentId
                // if user needs to respond
                for (let i of doc.pending) {
                    if (i.uid === firebase.auth().currentUser.uid) {
                        doc.needresponse = true
                        break
                    }
                }

                for (let i in doc.players) {
                    if (doc.players[i].uid === firebase.auth().currentUser.uid) {
                        new_pendings.push(doc)
                        break
                    }
                }
            });
            // console.log(new_pendings)
            setmypendings(new_pendings)
        });
    }

    React.useEffect(() => {
        getPendings()
    }, [])

    return (
        <Box sx={{ width: '100%', }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs id="Tabs" className="white-text" value={value} onChange={handleChange} >
                    <Tab className="Tab" label="Ladder" {...a11yProps(1)} />
                    {/* <Tab className="Tab" label="About" {...a11yProps(0)} /> */}
                    {/* <Tab className="Tab" label="New Match" {...a11yProps(2)} />
                    <Tab className="Tab"
                        label={<Badge badgeContent={mypendings.length} color="error">
                            Pending
                        </Badge>}
                        {...a11yProps(3)} /> */}
                </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
                <StickyHeadTable></StickyHeadTable>
            </TabPanel>
            {/* <TabPanel value={value} index={1}>
                <AboutLadder ></AboutLadder>
            </TabPanel> */}
            {/* <TabPanel value={value} index={2}>
                <AddMatch></AddMatch>
            </TabPanel>
            <TabPanel value={value} index={3}>

                <PendingMatch></PendingMatch>
            </TabPanel> */}
        </Box>
    );
}
